import {Carousel} from 'flowbite'

export default function initCarousel() {
    const carouselElement = document.getElementById('default-carousel')
    if (carouselElement) {
        const carouselItems = carouselElement.querySelectorAll('[data-carousel]')
        const next = document.querySelectorAll('[data-carousel-next]')
        const prev = document.querySelectorAll('[data-carousel-prev]')
        const dotNavs = document.querySelectorAll('[data-carousel-slide-to]')

        const carouselItemsArray = Array.from(carouselItems).map((el, index) => ({
            position: index,
            el: el,
        }))
        
        const options = {
            defaultPosition: 1,
            interval: 6000,
            indicators: {
                activeClasses: 'bg-white dark:bg-gray-800',
                inactiveClasses:
                    'bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800',
                items: carouselItemsArray,
            },
            // callback functions
            onNext: () => {
                // console.log('next slider item is shown');
            },
            onPrev: () => {
                // console.log('previous slider item is shown');
            },
            onChange: () => {
                // console.log('new slider item has been shown');
            },
        }
        // instance options object
        const instanceOptions = {
            id: 'carousel-default',
            override: true
        }

        const carousel = new Carousel(carouselElement, carouselItemsArray, options, instanceOptions)
        next[0].addEventListener('click', (e) => {
            carousel.next()
        })
        prev[0].addEventListener('click', (e) => {
            carousel.prev()
        })
        dotNavs.forEach((nav, i) => {
            nav.addEventListener('click', (e) => {
                carousel.slideTo(i)
            })
        })
        carousel.cycle()
    }

}